import { computed } from 'vue';
import useDivisionSelection from '@/state/composables/useDivisionSelection';
import { buildDivisionMap, divisionNames, formatDivisions } from '@/pages/recognition/utils/divisions';

export default () => {
  const { divisions } = useDivisionSelection();
  const divisionMap = computed(() => buildDivisionMap(divisions.value));

  return {
    divisionNamesFor: divisionIds => divisionNames(divisionIds, divisionMap.value),
    formatDivisionIds: divisionIds => formatDivisions(divisionIds, divisionMap.value),
  };
};
